export function toCamelCase(str: string) {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}

export function toOptions(results: { id: string | number; name: string }[]) {
  return results
    .map((item) => ({ label: item.name, value: item.id }))
    .sort((a, b) => a.label.localeCompare(b.label));
}

export function toWorkOptions(results: { id: string | number; title: string; form_id: string | number }[]) {
  return results
    .map((item) => ({ label: item.title, value: item.id, formId: item.form_id }))
    .sort((a, b) => a.label.localeCompare(b.label));
}

export function toAssigneeOptions(results: { id: string | number;
  user: {
    id: string | number;
    email: string;
    complete_name_and_email?: string;
  };}[]) 
  {
    return results.map((item) => ({
      label: item.user?.complete_name_and_email || item.user?.email,
      value: item.user.id,
    }));
}

export function toSnakeCase(str: string) {
  return str.replace(/([A-Z])/g, '_$1').toLowerCase();
}

export function strToLocaleString(dateStr: string) {
  const date = new Date(dateStr);
  return date.toLocaleString();
}

export function isNotEmptyElement(element: any) {
  if (element === null || typeof element === 'undefined') {
    return false;
  }

  if (Array.isArray(element) && element.length === 0) {
    return false;
  }

  return true;
}

interface JqueryPopover extends JQuery {
  popover: ({}) => any;
}

export function renderJqueryPopover(popoverClassName: string) {
  const jqueryPopover: JqueryPopover = $(popoverClassName);

  if (jqueryPopover.length > 0 && typeof jqueryPopover.popover === 'function') {
    jqueryPopover.popover({
      container: 'body',
      html: true,
      trigger: 'hover | focus',
      placement: 'auto',
    });
  }
}

export function maskValue(value?: string): string {
  if (!value) return '';
  return '•'.repeat(value.length);
}

export const hasValue = (value: unknown): boolean =>
  Array.isArray(value) ? value.length > 0 : Boolean(value)